/**
 * OPS-11: Control Tower API Service
 *
 * Frontend client for the OPS-10 Control Tower Backend endpoints.
 * Read-only — fetches operational intelligence for dashboard rendering.
 */

import { API_BASE } from '@/config/api';
import type { ControlTowerState, PortfolioControlTowerState } from './controlTowerTypes';

/**
 * Fetch single-hotel Control Tower state.
 * Endpoint rebuilds the full OPS pipeline on each call.
 */
export async function fetchControlTowerState(
  hotelId = 'default',
): Promise<ControlTowerState> {
  const url = `${API_BASE}/ops/control-tower/${encodeURIComponent(hotelId)}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch control tower state: ${response.statusText}`);
  }

  return response.json();
}

/**
 * Fetch portfolio Control Tower state for multiple hotels.
 */
export async function fetchPortfolioState(
  snapshots: unknown[],
): Promise<PortfolioControlTowerState> {
  const url = `${API_BASE}/ops/control-tower/portfolio`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snapshots),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch portfolio state: ${response.statusText}`);
  }

  return response.json();
}
